const toTop = {

    btn: document.getElementById('scrollTop'),

    init() {
        this.scrollTop();
    },

    scrollTop() {

        this.btn.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });

    }

}

export default toTop;